import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import SafeAnchorOffset from 'components/SafeAnchorOffset/SafeAnchorOffset';

import OpenFormHeading from './components/OpenFormHeading/OpenFormHeading';
import OpenForm from './components/OpenForm/OpenForm';
import { DefaultContainer } from './styles/DefaultContainer';

const OpenFormSection = forwardRef(({ children }, ref) => (
  <section ref={ref}>
    <SafeAnchorOffset id="quero-ser-cliente" />

    {children}
  </section>
));

OpenFormSection.Heading = OpenFormHeading;
OpenFormSection.Form = OpenForm;
OpenFormSection.DefaultContainer = DefaultContainer;

OpenFormSection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OpenFormSection;
